import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { Reveal } from './Reveal';
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="bg-paper px-5 py-20 sm:py-28 lg:px-8" aria-labelledby="colegas" data-id="element-256" data-mp="3fym68hdq8w2r">
      <div className="mx-auto max-w-6xl" data-id="element-257" data-mp="3b1ckbbpjr2jo">
        <Reveal data-id="element-258" data-mp="3b0axk9z64rm4">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-259" data-mp="3ayqcdayqul0x">
            <div data-id="element-260" data-mp="36wwipmmyuha9">
              <p className="text-[11px] font-extrabold uppercase tracking-[0.28em] text-grass" data-id="element-261" data-mp="31zwc9am7fcim">
                Usado por profes de todo el país
              </p>
              <h2 id="colegas" className="display mt-4 text-4xl text-ink sm:text-5xl" data-id="element-262" data-mp="2x11tg8o8lnyi">
                Lo que dicen los colegas
              </h2>
            </div>
            <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-ink-dim" data-id="element-263" data-mp="v9oqhp5txq53">
              <StarIcon className="h-4 w-4 fill-grass text-grass" aria-hidden="true" data-id="element-264" data-mp="qbeu5b8dcjhw" />
              4,9/5 · 2.500+ profes
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-3" data-id="element-265" data-mp="m4rowevdji7h">
          <Reveal className="h-full lg:row-span-2" data-id="element-266" data-mp="m6cia15ycv3r">
            <figure className="flex h-full flex-col rounded-xl bg-ink p-8 text-white sm:p-10" data-id="element-267" data-mp="78k2r90eo6pk">
              <blockquote className="text-2xl leading-snug sm:text-[1.75rem]" data-id="element-268" data-mp="c6bx09oiw4wx">
                “{featured.quote}”
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-3 pt-8" data-id="element-269" data-mp="zx7tvl7u5qb1">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-grass text-sm font-bold text-white" data-id="element-270" data-mp="14uhiiynehxxt">
                  {featured.initials}
                </span>
                <span data-id="element-271" data-mp="v4xz9rvs022f">
                  <span className="block text-sm font-bold uppercase tracking-wide" data-id="element-272" data-mp="v44z59rboat9">
                    {featured.name}
                  </span>
                  <span className="block text-sm text-white/60" data-id="element-273" data-mp="1nlqq32dm2cmr">{featured.role}</span>
                </span>
              </figcaption>
            </figure>
          </Reveal>

          {rest.map((t, i) => <Reveal key={t.name} delay={i * 0.04} className="h-full" data-id="element-274" data-mp="1sj5xvpgxl95k" data-mpi={i}>
              <figure className="flex h-full flex-col rounded-xl border border-paper-line bg-paper-soft p-7" data-id="element-275" data-mp="1sh37337yfbzs">
                <blockquote className="text-[17px] leading-relaxed text-ink" data-id="element-276" data-mp="1ji82fvkk69yl">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-auto flex items-center gap-3 pt-6" data-id="element-277" data-mp="1ek6il8fb66m2">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-grass-soft text-xs font-bold text-grass" data-id="element-278" data-mp="19rwl97bv649r">
                    {t.initials}
                  </span>
                  <span data-id="element-279" data-mp="10s03lpnw65o7">
                    <span className="block text-sm font-bold uppercase tracking-wide text-ink" data-id="element-280" data-mp="10sroa5fyaizp">
                      {t.name}
                    </span>
                    <span className="block text-sm text-ink-dim" data-id="element-281" data-mp="vuhu9y5ypofo">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}